import { InfoIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/Badge/Badge';
import { cn } from '@/lib/utils';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface LimitBadgeProps {
    className?: string;
    showLabel?: boolean;
}

export function LimitBadge({ className, showLabel = true }: LimitBadgeProps) {
    const { t } = useTranslation(I18nNamespace.COMMON);

    return (
        <Badge
            variant="base"
            className={cn('bg-transparent px-0 text-grey-300', className)}
        >
            <InfoIcon size={16} />
            {showLabel && (
                <span className="text-xs-medium">{t('actions.atLimit')}</span>
            )}
        </Badge>
    );
}
